"use strict";

import angular from "angular";

import template from "./ia-nanda-chat.component.html";
import "./ia-nanda-chat.component.scss";

import { DataCommunication } from "../../../gateway/DataCommunication";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";

export class IaNandaChatComponent {
    user = new UserDataAdapter().user();
    DataCommunication = new DataCommunication();
    textAreaHeight = 50;
    breakSpaceTextArea = 1;

    initialMessages = {
        type: "assistant",
        contents: [
            {
                type: "text-message",
                text: `Olá! Sou Nanda, sua assistente de análise. Posso te
                    ajudar a <strong>interpretar</strong> os indicadores,
                    <strong>identificar</strong> oportunidades de melhoria e
                    gerar insights estratégicos para seus clientes.`
            },
            {
                type: "text-message",
                text: `<span class="font-weight-semi-bold">Quer começar com uma dessas perguntas?</span>`
            },
            {
                type: "box-options",
                options: []
            }
        ]
    };
    messages = [
        this.initialMessages
        // {
        //     type: "user",
        //     contents: [
        //         {
        //             type: "text-message",
        //             text: `Quais os principais insights para esse Dashboard?`
        //         }
        //     ]
        // },
        // {
        //     type: "assistant",
        //     contents: [
        //         {
        //             type: "text-message",
        //             text: `<ul><li>Lucratividade em leve alta: O lucro líquido foi de R$8.534,98, mostrando um avanço neste mês. Continue controlando os custos para manter a rentabilidade em crescimento.</li>

        //             <li>Cuidado com custos fixos: A Folha de Pagamento representa 16,75% da receita — acompanhe para que não comprometa o resultado nos próximos meses.</li></ul>`
        //         }
        //     ]
        // },
        // {
        //     type: "user",
        //     contents: [
        //         {
        //             type: "text-message",
        //             text: `Como está a evolução da lucratividade ao logo dos últimos meses?`
        //         }
        //     ]
        // },
        // {
        //     type: "assistant",
        //     contents: [
        //         {
        //             type: "text-message",
        //             text: `A lucratividade vem evoluindo positivamente nos últimos meses — passando de 10,03% em mai/24 para 10,52% em mai/25 (+0,49 p.p.). Esse avanço reflete o crescimento das receitas e a redução de 7,6% nos gastos, resultando em um lucro líquido 226% maior.
        //             <br>
        //             <br>
        //             <strong>Insight:</strong> A tendência é favorável, mas a margem ainda está em torno de 10%.`,
        //             actions: [
        //                 {
        //                     type: "copy",
        //                     label: "Copiar",
        //                     icon: "far fa-copy"
        //                 },
        //                 {
        //                     type: "audio",
        //                     label: "Audio",
        //                     icon: "fas fa-volume-up"
        //                 },
        //                 {
        //                     type: "like",
        //                     label: "Curtir",
        //                     icon: "far fa-thumbs-up"
        //                 },
        //                 {
        //                     type: "dislike",
        //                     label: "Descurtir",
        //                     icon: "far fa-thumbs-down"
        //                 }
        //             ]
        //         },
        //         {
        //             type: "box-options",
        //             options: [
        //                 {
        //                     text:
        //                         "📝 Me dê sugestões de notas para os principais indicadores desse Dash."
        //                 },
        //                 {
        //                     text:
        //                         "📊 Houve alguma variação significativa nos indicadores em relação ao mês anterior?"
        //                 }
        //             ]
        //         }
        //     ]
        // }
    ];
    userMessage = "";
    loading = false;
    thinking = false;
    initialOptionsSelected = [];
    queueMessages = [];

    constructor($timeout, $scope, $rootScope) {
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
    }

    $onInit() {
        this.unsubscribeAnalyzeVisualization = this.$rootScope.$on(
            "IA_ANALYZE_VISUALIZATION",
            (event, visualization) => {
                this.onAnalyzeVisualization(visualization);
            }
        );
        this.initialMessages.contents[2].options = this.initialAsks;
        this.onViewInit();
        this.$timeout(() => {
            this.onResetScroll();
        }, 100);
    }

    $onDestroy() {
        if (this.unsubscribeAnalyzeVisualization) {
            this.unsubscribeAnalyzeVisualization();
        }
    }

    async onViewInit() {
        this.loading = true;
        const session = await this.DataCommunication.getChatSessionByUser({
            contextId: this.contextId,
            companyId: this.companyData._id,
            userId: this.user._id,
            limit: 50,
            page: 0
        });
        const messages = session.mensages?.reverse() || [];
        messages.forEach((message) => {
            this.addMessage({
                message: this.removeLinks(message?.message),
                type: message.role,
                time: new Date(message.time)
            });
        });
        this.loading = false;
        if (this.queueMessages?.length > 0) {
            this.sendMessageToIAInsightKpi(this.queueMessages?.[0]);
            this.queueMessages = [];
        }
        this.$scope.$applyAsync();
        this.$timeout(() => {
            this.onScrollBoth();
        }, 100);
    }

    onResetScroll() {
        const element = document.querySelector(
            ".ia-nanda-chat-component__content__section"
        );
        if (!element) return;
        element.scrollTo(0, element.scrollHeight);
    }

    onScrollBoth() {
        const element = document.querySelector(
            ".ia-nanda-chat-component__content__section"
        );
        if (!element) return;
        element.scrollTo({
            top: element.scrollHeight,
            left: element.scrollWidth,
            behavior: "smooth"
        });
    }

    onSendMessage() {
        if (this.thinking) return;
        this.addMessage({
            message: this.userMessage,
            type: "user",
            time: new Date()
        });
        this.sendMessageToIA({ message: this.userMessage });
        this.userMessage = "";
        this.$timeout(() => {
            this.onScrollBoth();
        }, 100);
    }

    onKeyPressSendMessage(event) {
        if (event.key !== "Enter") return;
        this.onSendMessage(event);
    }

    onAnalyzeVisualization(visualization) {
        if (this.thinking) {
            return;
        }
        if (this.loading) {
            if (this.queueMessages.length === 0) {
                this.queueMessages.push(visualization);
            }
            return;
        }
        this.sendMessageToIAInsightKpi(visualization);
        this.queueMessages = [];
    }

    sendMessageToIAInsightKpi(visualization) {
        if (this.thinking || !visualization) return;
        const message = `Quais os principais insights para o indicador ${visualization.name}?`;
        this.addMessage({
            message,
            type: "user",
            time: new Date()
        });
        this.sendMessageToIA({ message, isInsightKpi: visualization.name });
        this.$timeout(() => {
            this.onScrollBoth();
        }, 100);
    }

    async sendMessageToIA({ message, isInsightKpi = "" }) {
        this.thinking = true;
        const response = await this.DataCommunication.replyToUser({
            companyId: this.companyData._id,
            userId: this.user._id,
            message,
            isSummary: false,
            isInsightKpi,
            contextId: this.contextId,
            options: {
                ...this.options
            }
        });
        this.thinking = false;
        if (response?.message) {
            this.addMessage({
                message: response.message,
                type: "assistant",
                time: new Date()
            });
        }
        this.$scope.$applyAsync();
        this.$timeout(() => {
            this.scrollFromCurrentPosition(300);
        }, 100);
    }

    scrollFromCurrentPosition(pixels) {
        const element = document.querySelector(
            ".ia-nanda-chat-component__content__section"
        );
        if (!element) return;
        element.scrollTo({
            top: element.scrollTop + pixels,
            left: element.scrollWidth,
            behavior: "smooth"
        });
    }

    addMessage({ message, type, time }) {
        const actions = [
            {
                value: "copy",
                label: "Copiar",
                icon: "far fa-copy"
            },
            {
                value: "audio",
                label: "Audio",
                icon: "fas fa-volume-up"
            }
            // {
            //     value: "like",
            //     label: "Gostei",
            //     icon: "far fa-thumbs-up"
            // },
            // {
            //     value: "dislike",
            //     label: "Não gostei",
            //     icon: "far fa-thumbs-down"
            // }
        ];
        const newMessage = {
            type,
            time,
            contents: [
                {
                    type: "text-message",
                    text: this.removeLinks(message),
                    actions: type === "assistant" ? actions : []
                }
            ]
        };
        this.messages.push(newMessage);
    }

    async onClearMessages() {
        this.DataCommunication.removeChatSessionByUser({
            companyId: this.companyData._id,
            userId: this.user._id,
            contextId: this.contextId
        });
        this.messages = [this.initialMessages];
        this.initialOptionsSelected = [];
        this.$timeout(() => {
            this.onScrollBoth();
            this.$scope.$applyAsync();
        }, 100);
    }

    async onSelectOption(option) {
        if (this.thinking) return;
        this.initialOptionsSelected.push(option.value);
        this.addMessage({
            message: option.text,
            type: "user",
            time: new Date()
        });
        this.$timeout(() => {
            this.onScrollBoth();
        }, 100);
        await this.sendMessageToIA({ message: option.text });
        const leftOptions = this.initialAsks.filter(
            (option) => !this.initialOptionsSelected.includes(option.value)
        );
        if (leftOptions.length > 0) {
            const newMessage = {
                type: "assistant",
                contents: [
                    {
                        type: "box-options",
                        options: leftOptions
                    }
                ]
            };
            this.messages.push(newMessage);
        }
        this.$scope.$applyAsync();
    }

    removeLinks(message) {
        if (!message) return "";
        return message.replace(/<a\b[^>]*>(.*?)<\/a>/gi, "<b>$1</b>");
    }

    onHeightChange() {
        const currentLength = this.userMessage.length;
        const expectedBreaks = Math.ceil(currentLength / 82);
        const expectedHeight = 50 + (expectedBreaks - 1) * 50;
        if (expectedHeight > 250) {
            this.textAreaHeight = 250;
            this.breakSpaceTextArea = Math.ceil((250 - 50) / 50) + 1;
        } else if (expectedHeight < 50) {
            this.textAreaHeight = 50;
            this.breakSpaceTextArea = 1;
        } else {
            this.textAreaHeight = expectedHeight;
            this.breakSpaceTextArea = expectedBreaks;
        }
    }
}

IaNandaChatComponent.$inject = ["$timeout", "$scope", "$rootScope"];

const name = "iaNandaChatComponent";
const def = {
    bindings: {
        initialAsks: "<",
        accountingData: "<",
        companyData: "<",
        contextId: "<",
        options: "<",
        handleClose: "&"
    },
    controller: IaNandaChatComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
